import Api from "../services/Api";
import { ApiResponse } from "apisauce";

export function print(url, notificationIds) {
  Api.post(url, { ids: notificationIds })
    .then((response: ApiResponse<any>) => {
      //console.log('pdf response', response);
      if (response.data && response.data.length > 0) {
        let pdfWindow = window.open("");
        pdfWindow.window.document.title = "Print Notifications";
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(response.data) +
            "'></iframe>"
        );
      }
      // delay(function() {
      //   // do stuff
      //   pdfWindow.print();
      // }, 10000); // end delay
    })
    .catch(function (error) {
      console.log(error);
    });
}

export const printAsync = async (url, notificationIds) => {
  try {
    const response: ApiResponse<any> = await Api.post(url, { ids: notificationIds });
    if (response.ok && response.data && response.data.length > 0) {
      let pdfWindow = window.open("");
      pdfWindow.window.document.title = "Print Notifications";
      pdfWindow.document.write(
        "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
          encodeURI(response.data) +
          "'></iframe>"
      );
    }
  } catch (ex) {
    console.log(ex);
  }
};

export function remove(url, notificationIds) {
  Api.post(url, { ids: notificationIds })
    .then((response: ApiResponse<any>) => {
      //console.log(response);
    })
    .catch(function (error) {
      console.log(error);
    });
}

export const removeAsync = async (url, notificationIds) => {
  try {
    await Api.post(url, { ids: notificationIds });
  } catch (ex) {
    console.log(ex);
  }
};

var delay = (function () {
  var timer: any = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
